import axios from "axios";
import { api } from "../Constants/project";
import { logout } from "../../Modules/Auth/Api/Login";

// Crea una instancia de Axios
const axiosInstance = axios.create({
  baseURL: api, // Reemplaza con tu URL base
});

// Interceptor de respuesta
axiosInstance.interceptors.response.use(
  (response) => response, // Deja pasar las respuestas exitosas
  (error) => {
    if (error.response?.status === 401) {
      //alertError("Acceso no autorizado");
      // Token expirado o no autorizado
      logout(); // Cierra la sesión (puedes limpiar el almacenamiento local, el contexto, etc.)
    }
    return Promise.reject(error); // Propaga el error para manejarlo más adelante si es necesario
  }
);

// Agregar interceptor de solicitud
axiosInstance.interceptors.request.use(
  (config) => {
    // Obtén el token de autenticación desde el almacenamiento local o cualquier lugar
    const token = localStorage.getItem("token"); // O usa otro método de almacenamiento

    // Si hay un token, lo agrega a los headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config; // Devuelve la configuración modificada
  },
  (error) => {
    // Manejar errores antes de enviar la solicitud
    return Promise.reject(error);
  }
);

export default axiosInstance;
